import { createErrorSelector, createLoadingSelector } from "../../utils/reduxUtils";
import { LOGIN_USER } from "../actions";

export const loginLoadingSelector = createLoadingSelector([LOGIN_USER]);
export const loginErrorSelector = createErrorSelector([LOGIN_USER]);